import React from 'react';

import NotificationsPage from "./NotificationsPage";

interface NotificationsPageProps {}

const NotificationsPageContainer: React.FC<NotificationsPageProps> = () => {
    return <NotificationsPage />
}

export default NotificationsPageContainer;